// extracted by mini-css-extract-plugin
export default {"chooseRegions":"ChooseRegions_chooseRegions__SaKMn","chooseRegionsBody":"ChooseRegions_chooseRegionsBody__-YMWJ","region":"ChooseRegions_region__D8slT"};